import React from 'react';
import Cookie from "js-cookie";
import { Navigate, Outlet } from 'react-router-dom'

const useAuth = () => {
    const user = Cookie.get('userInfo')
    if (user) {
        return true
    } else {
        return false
    }
}
export const ProtectedRoute1 = () => {
    return useAuth() ? <Outlet /> : <Navigate to="/pvtOfficer-login" />;
}

export const ProtectedRoute3 = () => {
    return useAuth() ? <Outlet /> : <Navigate to="/bospanel-login" /> ;
}

export const ProtectedRoute2 = () => {
    return useAuth() ? <Outlet /> : <Navigate to="/" /> ;
}